import { cssSpacing, rootStyle } from "../../styles/index.mjs";
import styled, { css } from "../../styled-components.mjs";
export var Group = styled.div.withConfig({
  displayName: "Group",
  componentId: "sc-u9bcx5-0"
})(["", ";padding-block-end:", ";", ";"], rootStyle(), cssSpacing('looser', '24px'), function (_ref) {
  var as = _ref.as;
  return as === 'fieldset' && css(["min-inline-size:0;padding-inline:0;padding-block-start:0;margin:0;border:0;"]);
});